import React from 'react';
import ExtrasLayout from '@/components/layout/ExtrasLayout';
import { Link } from 'react-router-dom';

const Privacy: React.FC = () => {
  return (
    <ExtrasLayout title="Privacy Policy">
      <h4 className="extra-page__heading">Overview</h4>
      <p>
        This Privacy Policy describes how Ephemera Partners, L.P. (“Ephemera,” “we,” or “us”)
        collects, uses, and protects information obtained through this website.
      </p>
      <h4 className="extra-page__heading">Information We Collect</h4>
      <p>We may collect limited personal information that you voluntarily provide, such as:</p>
      <ul>
        <li>name;</li>
        <li>email address;</li>
        <li>contact details submitted through forms or email communications.</li>
      </ul>
      <p>We may also collect non-personal information automatically, including:</p>
      <ul>
        <li>IP address;</li>
        <li>browser type;</li>
        <li>device information;</li>
        <li>usage data (e.g., pages visited, time spent).</li>
      </ul>
      <h4 className="extra-page__heading">Use of Information</h4>
      <p>Information collected is used solely to:</p>
      <ul>
        <li>respond to inquiries;</li>
        <li>operate & improve the Site;</li>
        <li>monitor usage & maintain security;</li>
        <li>comply within legal or regulatory obligations.</li>
      </ul>
      <p>Ephemera does not sell, rent, or trade personal information.</p>
      <h4 className="extra-page__heading">Cookies and Analytics</h4>
      <p>
        The Site may use cookies or similar technologies to enhance functionality and understand
        usage patterns. Where analytics tools are used, data is aggregated and anonymized to the
        extent reasonably practicable. You may adjust your browser settings to refuse cookies.
      </p>
      <h4 className="extra-page__heading">Disclosure of Information</h4>
      <p>We may disclose information:</p>
      <ul>
        <li>as required by law or regulation;</li>
        <li>
          to service providers assisting with Site operations (subject to confidentiality
          obligations).
        </li>
      </ul>
      <h4 className="extra-page__heading">Data Security</h4>
      <p>
        We implement reasonable administrative, technical, and organizational measures to protect
        personal information. However, no method of transmission over the internet is completely
        secure.
      </p>
      <h4 className="extra-page__heading">Data Retention</h4>
      <p>
        Personal information is retained only for as long as necessary to fulfil the purposes for
        which it was collected or as required by applicable law.
      </p>
      <h4 className="extra-page__heading">International Users</h4>
      <p>
        This Site may be accessed globally. By using the Site, you acknowledge that information
        may be processed in jurisdictions with data protection standards different from those of
        your home jurisdiction.
      </p>
      <h4 className="extra-page__heading">Your Rights</h4>
      <p>
        Depending on applicable law, you may have rights to access, correct, or request deletion
        of your personal information. Requests may be submitted via the{' '}
        <b>
          <Link to="/principals#contact">contact form</Link>
        </b>
        .
      </p>
      <h4 className="extra-page__heading">Updates</h4>
      <p>
        This Privacy Policy may be updated from time to time. Updates will be posted on this page.
      </p>
      <p className="extra-page__accent">© Ephemera Partners, L.P. All rights reserved.</p>
    </ExtrasLayout>
  );
};

export default Privacy;
